import { combineReducers } from 'redux';
import { AppReducer } from './App/AppReducer';


export default combineReducers({
    AppReducer,
})